import { useAtomValue } from 'jotai';

import { usePayments } from '../../../context/PaymentsProvider';
import { isStripeLoadedAtom } from '../../../context/StripeProviderStore';
import StripeNotLoadedError from '../../StripeNotLoadedError/StripeNotLoadedError';

import FpxComponent from './FpxComponent';

const Fpx = () => {
  const { fpx } = usePayments();
  const stripeIsLoaded = useAtomValue(isStripeLoadedAtom);

  if (!stripeIsLoaded) {
    return <StripeNotLoadedError />;
  }

  if (!fpx) {
    return <></>;
  }

  const { handleOnChangeInternetBank } = fpx;

  return (
    <>
      <FpxComponent onBankChange={handleOnChangeInternetBank} />
    </>
  );
};

export default Fpx;
